import { render } from "./contact_element.vue?vue&type=template&id=2294b734&scoped=true"
import script from "./contact_element.vue?vue&type=script&lang=js"
export * from "./contact_element.vue?vue&type=script&lang=js"

import "./contact_element.vue?vue&type=style&index=0&id=2294b734&lang=less&scoped=true"

import exportComponent from "/Users/aa/work/credit_chakra_ios/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2294b734"]])

export default __exports__